/* ScrollItem.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _50 = "._1y9gglyw div{border:none}";
const _49 = "._mezj1osq img{width:100%}";
const _48 = "._bna71wug img{height:auto}";
const _47 = "._v4pn1ule img{display:block}";
const _46 = "._f45rh2mm img{position:relative}";
const _45 = "._m3691ur6 img{animation:fadein .25s 1}";
const _44 = "._10ew1wug img{margin-left:auto}";
const _43 = "._18741wug img{margin-bottom:auto}";
const _42 = "._1hlx1wug img{margin-right:auto}";
const _41 = "._1cr61wug img{margin-top:auto}";
const _40 = "._u7co15qf{inset-block-end:-10%}";
const _39 = "._1e023ll0{inset-inline-start:-3%}";
const _38 = "._1bsbx19p{width:20%}";
const _37 = "._152tidpf{inset-block-start:0}";
const _36 = "._1e02idpf{inset-inline-start:0}";
const _35 = "._kqswstnw{position:absolute}";
const _34 = "._4t3i1osq{height:100%}";
const _33 = "._v564t24z{transition:all 1s}";
const _32 = "@media not all and (min-width:64rem){._1mjb1ule{display:block}._dh1a1h6o{align-items:center}}";
const _31 = "._1bsb1osq{width:100%}";
const _30 = "._1h1t15ju{aspect-ratio:7/4}";
const _29 = "._1e0cglyw{display:none}";
const _28 = "._18s89wlp{margin:var(--ds-space-300,24px) auto var(--ds-space-400,2pc)}";
const _27 = "@media not all and (min-width:64rem){._2osnpxbi{gap:var(--ds-space-200,1pc)}._na0i1bp4{flex-direction:column}}";
const _26 = "@media not all and (min-width:48rem){._8164v47k{gap:var(--ds-space-250,20px)}._suga1txw{display:flex}._1gdevrvc{flex-direction:row}._nssp1h6o{justify-content:center}._ag851h6o{align-items:center}}";
const _25 = "._2lx2vrvc{flex-direction:row}";
const _24 = "._zulpv47k{gap:var(--ds-space-250,20px)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines-per-function */
import { Box, xcss } from '@atlaskit/primitives';
import { media } from '@atlaskit/primitives/responsive';
import { BodyNormal, H4, Image, LinkWithIcon } from '@atlassian/mpac-primitives';
import { useContext, useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import HighlightedText from '../HighlightedText/HighlightedText';
import { ScrollContext } from './types';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _23 = "@media not all and (min-width:64rem){._qwozidpf{-webkit-margin-end:0;margin-inline-end:0}._gu181h6o{text-align:center}}";
const _22 = "@media not all and (min-width:64rem){._dh1a1h6o{align-items:center}}";
const _21 = "._zulputpp{gap:var(--ds-space-150,9pt)}";
const _20 = "@media not all and (min-width:64rem){._gu181h6o{text-align:center}}";
const _19 = "._k48p1fw0{font-weight:700}";
const _18 = "._18u0idpf{margin-left:0}";
const _17 = "._otyridpf{margin-bottom:0}";
const _16 = "._2hwxidpf{margin-right:0}";
const _15 = "._19pkidpf{margin-top:0}";
const _14 = "@media not all and (min-width:64rem){._o5kc1h6o{justify-content:center}}";
const _13 = "._4cvr1h6o{align-items:center}";
const _12 = "@media not all and (min-width:64rem){._o5kc1h6o{justify-content:center}._dh1a1h6o{align-items:center}}";
const _11 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _10 = "._zulp1j6v{gap:1rem}";
const _9 = "@media not all and (min-width:64rem){._101fkb7n{opacity:1}._dh1a1h6o{align-items:center}}";
const _8 = "._1wpz1fhb{align-self:stretch}";
const _7 = "._4cvr1y6m{align-items:flex-start}";
const _6 = "._2lx21bp4{flex-direction:column}";
const _5 = "._zulp1ejb{gap:var(--ds-space-300,24px)}";
const _4 = "@media not all and (min-width:64rem){._1eglxy5q{-webkit-margin-after:var(--ds-space-400,2pc);margin-block-end:var(--ds-space-400,2pc)}._na0i1bp4{flex-direction:column}._dh1a1h6o{align-items:center}}";
const _3 = "._6rth172j{-webkit-margin-after:6.25rem;margin-block-end:6.25rem}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._kqswh2mm{position:relative}";
const styles = xcss({
  borderRadius: '8px',
  borderWidth: '1px',
  display: 'flex',
  alignItems: 'center'
});
export const HomepageSectionScrollItem = props => {
  const {
    ref: scrollRef,
    inView: sectionIsVisible
  } = useInView({
    threshold: 0.1,
    rootMargin: '-45% 0px -45% 0px',
    trackVisibility: true,
    delay: 100
  });
  const {
    setActiveAccentImg,
    setActiveColor,
    setActiveShape,
    setActiveFeatureVideo,
    setActivePosterImage,
    setActiveIndex
  } = useContext(ScrollContext);
  useEffect(() => {
    if (sectionIsVisible) {
      setActiveAccentImg(props.accentImg || null);
      setActiveColor(props.bgColor || '');
      setActiveIndex(props.index || 0);
      setActiveShape(props.bgShape || '');
      setActivePosterImage(props.posterImage);
      setActiveFeatureVideo(props.featureVideo || '');
    }
  });
  const posterImageDimensions = {
    width: 1920,
    height: 1080
  };
  const ref = useRef(null);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsxs("div", {
      id: "product-type-".concat(props.productName.toLowerCase().replace(/\s+/g, '-')),
      className: ax(["_kqswh2mm _1e0c1txw _6rth172j _1eglxy5q _na0i1bp4 _dh1a1h6o", "product-type"]),
      ref: ref,
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_5, _2, _6, _7, _8, _9]
        }), /*#__PURE__*/_jsxs("div", {
          ref: scrollRef,
          className: ax(["_zulp1ejb _1e0c1txw _2lx21bp4 _4cvr1y6m _1wpz1fhb _101fkb7n _dh1a1h6o"]),
          children: [/*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_10, _2, _6, _7, _8]
            }), /*#__PURE__*/_jsxs("div", {
              className: ax(["_zulp1j6v _1e0c1txw _2lx21bp4 _4cvr1y6m _1wpz1fhb"]),
              children: [/*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_11, _2, _6, _7, _8, _12]
                }), /*#__PURE__*/_jsxs("div", {
                  className: ax(["_zulpu2gc _1e0c1txw _2lx21bp4 _4cvr1y6m _1wpz1fhb _o5kc1h6o _dh1a1h6o"]),
                  children: [/*#__PURE__*/_jsxs(CC, {
                    children: [/*#__PURE__*/_jsx(CS, {
                      children: [_11, _2, _13, _8, _14]
                    }), /*#__PURE__*/_jsxs("div", {
                      className: ax(["_zulpu2gc _1e0c1txw _4cvr1h6o _1wpz1fhb _o5kc1h6o"]),
                      children: [/*#__PURE__*/_jsx(Box, {
                        padding: "space.025",
                        xcss: styles,
                        children: /*#__PURE__*/_jsx("img", {
                          src: props.logo,
                          alt: "brand",
                          width: 20,
                          height: 20
                        })
                      }), /*#__PURE__*/_jsx(BodyNormal, {
                        as: "span",
                        children: props.productName
                      })]
                    })]
                  }), /*#__PURE__*/_jsxs(CC, {
                    children: [/*#__PURE__*/_jsx(CS, {
                      children: [_15, _16, _17, _18, _19, _20]
                    }), /*#__PURE__*/_jsx(H4, {
                      as: "h3",
                      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1fw0 _gu181h6o"]),
                      children: props.header
                    })]
                  })]
                })]
              }), /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_21, _2, _6, _7, _8, _22]
                }), /*#__PURE__*/_jsxs("div", {
                  className: ax(["_zulputpp _1e0c1txw _2lx21bp4 _4cvr1y6m _1wpz1fhb _dh1a1h6o"]),
                  children: [/*#__PURE__*/_jsxs(CC, {
                    children: [/*#__PURE__*/_jsx(CS, {
                      children: [_23]
                    }), /*#__PURE__*/_jsx(BodyNormal, {
                      className: ax(["_qwozidpf _gu181h6o"]),
                      children: props.description
                    })]
                  }), /*#__PURE__*/_jsx(HighlightedText, _objectSpread({}, props.keywordsConfig))]
                })]
              })]
            })]
          }), props.productCTA && /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_24, _2, _25, _13, _26, _27]
            }), /*#__PURE__*/_jsx("div", {
              className: ax(["_zulpv47k _1e0c1txw _2lx2vrvc _4cvr1h6o _8164v47k _suga1txw _1gdevrvc _nssp1h6o _ag851h6o _2osnpxbi _na0i1bp4"]),
              children: /*#__PURE__*/_jsx(LinkWithIcon, {
                href: props.productCTA.url,
                type: "internal",
                size: "medium",
                "aria-label": props.productCTA.ariaLabel,
                dataTestId: "cta-link",
                animateIcon: true,
                underlineText: false,
                onClick: event => {
                  var _props$onProductCTACl;
                  return (_props$onProductCTACl = props.onProductCTAClick) === null || _props$onProductCTACl === void 0 ? void 0 : _props$onProductCTACl.call(props, event, props);
                },
                children: props.productCTA.text
              })
            })]
          })]
        })]
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_28, _29, _, _30, _31, _32]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_18s89wlp _1e0cglyw _kqswh2mm _1h1t15ju _1bsb1osq _1mjb1ule _dh1a1h6o"]),
          children: [props.bgShape && props.bgColor && /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_33, _31, _34, _35, _36, _37]
            }), /*#__PURE__*/_jsx("div", {
              style: {
                clipPath: "polygon(".concat(props.bgShape, ")"),
                backgroundColor: "#".concat(props.bgColor)
              },
              className: ax(["_v564t24z _1bsb1osq _4t3i1osq _kqswstnw _1e02idpf _152tidpf"])
            })]
          }), props.accentImg && /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_38, _35, _39, _40]
            }), /*#__PURE__*/_jsx("div", {
              "data-testid": "accent-img",
              className: ax(["_1bsbx19p _kqswstnw _1e023ll0 _u7co15qf"]),
              children: props.accentImg
            })]
          }), /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_41, _42, _43, _44, _45, _46, _47, _48, _49, _50]
            }), /*#__PURE__*/_jsx("div", {
              className: ax(["_1cr61wug _1hlx1wug _18741wug _10ew1wug _m3691ur6 _f45rh2mm _v4pn1ule _bna71wug _mezj1osq _1y9gglyw"]),
              children: /*#__PURE__*/_jsx(Image, {
                "data-testid": "poster-img",
                src: props.posterImage,
                alt: "",
                width: "".concat(posterImageDimensions.width),
                height: "".concat(posterImageDimensions.height),
                aspectRatio: "".concat(posterImageDimensions.width, "/").concat(posterImageDimensions.height)
              })
            })]
          })]
        })]
      })]
    })]
  });
};
const productTypeStyles = null;
const productCardStyles = null;
const contentStyles = null;
const headerStyles = null;
const brandStyles = null;
const bodyStyles = null;
const imgRegionStyles = null;
const mainHeadingStyles = null;
const bgShapeStyles = null;
const imgAccentStyles = null;
const descriptionStyles = null;
const imgScreenshotStyles = null;
const exploreProductWrapper = null;